import { createAction } from '@reduxjs/toolkit';

import { DashboardState } from './dashboard.reducer';

const prefix = 'dashboard';

export const dashboardActions = {
  setLastVisitedUrl: createAction<DashboardState['lastVisitedUrl']>(
    `${prefix}/setLastVisitedUrl`,
  ),
};
